import { groupingMessages } from '../groupingMessages';

import type { IntlShape } from 'react-intl';
import type { GroupFamily } from '../../domain/grouping.types';
import type { GroupingNotice } from '../groupingNotice.types';

/** Text of the notification shown after a grouping change. */
export function formatGroupingNotice(
  formatMessage: IntlShape['formatMessage'],
  family: GroupFamily,
  notice: GroupingNotice
): string {
  if (notice.kind === 'cartography') {
    const summary = formatMessage(groupingMessages.notificationCartography, {
      created: notice.createdCount,
      updated: notice.updatedCount
    });
    if (!notice.excludedCount) {
      return summary;
    }
    const excluded = formatMessage(groupingMessages.notificationCartographyExcluded, {
      items: formatMessage(groupingMessages.familyItemsCount, { count: notice.excludedCount, family })
    });
    return `${summary} ${excluded}`;
  }
  const name = notice.groupName;
  switch (notice.kind) {
    case 'created':
      return formatMessage(groupingMessages.notificationCreated, {
        items: formatMessage(groupingMessages.familyItemsCount, { count: notice.itemCount, family }),
        name
      });
    case 'added':
      return formatMessage(groupingMessages.notificationAdded, {
        items: formatMessage(groupingMessages.familyItemsCount, { count: notice.itemCount, family }),
        name
      });
    case 'updated':
      return formatMessage(groupingMessages.notificationUpdated, { name });
    default:
      return formatMessage(groupingMessages.notificationDeleted, { name });
  }
}
